<template>
  <div align="center" class="p-3">
 
    <h4 class="text_box2_1_1">    <img src="@/assets/images/NikhomLatKrabang/3.png" style="width: 30px;"  alt="" /> {{ header }}</h4>
  </div>
</template>

<script>
export default { props: ["header"] };
</script>

<style scoped>
.text_box2_1_1 {
  /* margin-left: 5px; */
  font-size: 1rem;
  /* position: absolute; */
  width: 100%;
  /* margin-top: 20px; */
  font-weight: 600;
  color: #707070;
}
@media only screen and (max-width: 700px) {
}
</style>